import React from 'react'
import { message } from 'antd'
import Spin from 'components/atoms/Spin'

export default class MessageManager {
  constructor() {
    this.hideLoading = null
  }

  success(content) {
    this.stopLoading()
    message.success(<span>{content.replace('\n', '<br />')}</span>)
  }

  warning(content) {
    this.stopLoading()
    message.warning(<span>{content.replace('\n', '<br />')}</span>)
  }

  error(content) {
    this.stopLoading()
    message.error(<span>{content.replace('\n', '<br />')}</span>)
  }

  startLoading() {
    this.stopLoading()
    this.hideLoading = message.loading(<Spin />, 0)
  }

  stopLoading() {
    if (this.hideLoading) this.hideLoading()
    this.hideLoading = null
  }
}

export const messageManager = new MessageManager()
